import React, { useEffect, useState } from "react";
import BurgerMenuTitle from "../../Component/BurgerMenuTitle/BurgerMenuTitle";
import {
  getUserInfoByIDAPI,
  transferAmountAPI,
} from "../../Api/BarestServices";
import { useParams } from "react-router-dom";
import { errorToast, succToast } from "../../Toast/Toast";
import { Input, Select, Skeleton } from "antd";
import Style from "./CreditTransfer.module.css";
import { separate } from "./../../Seprate/Seprate";
const CreditTransfer = () => {
  const params = useParams();
  const [userDataState, setUSerDataState] = useState();
  const [amountSate, setAmountState] = useState();
  const [loadigState, setLoadingState] = useState(false);
  const transferReasons = [
    { value: 0, label: "واریز حقوق" },
    { value: 1, label: "امور بیمه خدمات" },
    { value: 2, label: "امور درمانی" },
    { value: 3, label: "امور سرمایه‌گذاری و بورس" },
    { value: 4, label: "امور ارزی در چارچوب مقررات" },
    { value: 5, label: "پرداخت قرض و تأدیه دیون" },
    { value: 6, label: "امور بازنشستگی" },
    { value: 7, label: "معاملات اموال منقول" },
    { value: 8, label: "معاملات اموال غیرمنقول" },
    { value: 9, label: "عوارض گمرکی" },
    { value: 10, label: "تسویه مالیاتی" },
    { value: 11, label: "سایر خدمات دولتی" },
    { value: 12, label: "تسهیلات و تعهدات" },
    { value: 13, label: "تودیع وثیقه" },
    { value: 14, label: "هزینه عمومی و امور روزمره" },
    { value: 15, label: "کمک‌های خیریه" },
    { value: 16, label: "خرید کالا" },
    { value: 17, label: "خرید خدمات" },
  ];
  let info = {
    id: params.userId,
    type: params.userType,
  };
  useEffect(() => {
    getUserInfoByIDAPI(info, (res) => {
      if (res.status === 1) {
        setUSerDataState(res.list);
      } else {
        errorToast(res.message);
      }
    });
  }, []);
  const transferMoneyHandler = () => {
    if (!amountSate) {
      errorToast("مبلغ را وارد کنید!");
      return;
    }
    setLoadingState(true);
    info.amount = amountSate;
    info.transfer_cause = 5;
    transferAmountAPI(info, (res) => {
      if (res.status === 1) {
        setLoadingState(false);
        succToast("انتقال با موفقیت انجام شد!");
      } else {
        errorToast(res.message);
        setLoadingState(false);
      }
    });
  };
  return (
    <div>
      <BurgerMenuTitle title={"مدیریت اعتبار کیف پول"} goHome={true}/>
      <section className={Style.contentHolder}>
        <img src="/Assets/Images/Menu/transformMoney.svg" alt="" />
        {!userDataState && <Skeleton active style={{ maxWidth: "450px" }} />}
        {userDataState && (
          <div className={Style.FormHolder}>
            <p>
              انتقال به حساب:{" "}
              <span>{`${userDataState?.first_name} ${userDataState?.last_name}`}</span>
            </p>
            <p>
              با شماره همراه : <span>{userDataState?.phone}</span>
            </p>
            {/* <label htmlFor="reason">دلیل انتقال:</label>
            <Select
              style={{ width: "100%", marginBottom: "0.5rem" }}
              notFoundContent={
                <p
                  style={{
                    fontFamily: "iran-sans-num",
                    width: "100%",
                    textAlign: "100%",
                  }}
                >
                  یافت نشد!
                </p>
              }
              showSearch
              placeholder="یک دلیل انتخاب کنید"
              optionFilterProp="label"
              onChange={setTransferReasonsState}
              options={transferReasons}
              dropdownStyle={{direction:'rtl',fontFamily: "iran-sans-num",}}
              id="reason"
            /> */}
            <label htmlFor="paymentAmount">به مبلغ:</label>
            <Input
              id="paymentAmount"
              type="number"
              placeholder="مبلغ را به تومان وارد کنید"
              value={amountSate}
              onChange={(e) => setAmountState(e.target.value)}
            />
            {amountSate && (
              <p style={{ color: "green" }}>{separate(amountSate)} تومان</p>
            )}

            <button
              className={Style.ButtonHolder}
              onClick={transferMoneyHandler}
              disabled={loadigState}
            >
              {loadigState ? "منتظر بمانید..." : "پرداخت"}
            </button>
          </div>
        )}
      </section>
    </div>
  );
};

export default CreditTransfer;
